import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

interface LanguageSelectionModalProps {
  isOpen: boolean;
  onLanguageSelect: (language: 'en' | 'es') => void;
  onClose: () => void;
}

export const LanguageSelectionModal: React.FC<LanguageSelectionModalProps> = ({
  isOpen,
  onLanguageSelect,
  onClose,
}) => {
  const { t } = useLanguage();

  if (!isOpen) return null;

  const handleLanguageChoice = (language: 'en' | 'es') => {
    const message = language === 'es' 
      ? '¿Confirma que desea generar los PDFs en español?'
      : 'Do you confirm you want to generate PDFs in English?';
    
    const confirmed = window.confirm(message);
    if (confirmed) {
      onLanguageSelect(language);
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4 shadow-2xl">
        <div className="text-center">
          <h2 className="text-2xl font-semibold text-gray-900 mb-2">
            {t('languagePicker.welcome')}
          </h2>
          <p className="text-gray-600 mb-8">
            {t('languagePicker.chooseLanguage')}
          </p>
          
          <div className="space-y-4">
            <button
              onClick={() => handleLanguageChoice('en')}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-4 px-6 rounded-lg transition-colors duration-200 text-lg"
            >
              {t('languagePicker.english')}
            </button>
            
            <button
              onClick={() => handleLanguageChoice('es')}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-4 px-6 rounded-lg transition-colors duration-200 text-lg"
            >
              {t('languagePicker.spanish')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};